import { isPermissioned } from '@src/model/user/permission';
import { usePost } from '@src/store/posts/hooks/usePost';
import type { FC } from 'react';
import ContentModScore from '../ContentModScore';

interface PostViewModScoreProps {
    postId: string;
    tokenName: string;
}

export const PostViewModScore: FC<PostViewModScoreProps> = props => {
    const { postId, tokenName } = props;

    const post = usePost(postId);

    if (!post || !post.moderationScore || !post.moderationContent) return null;
    if (!isPermissioned(tokenName, 'hideContent')) return null;
    if (post.kind === 'story') return null;

    return <ContentModScore moderationContent={post.moderationContent} moderationScore={post.moderationScore} />;
};
